import React from 'react'
import PropTypes from 'prop-types'
import { IconIllustrativeMessage, Spinner } from '@blocket/blocket-ui'
import LoadedChannel from './LoadedChannel'
import { InfoContainer, TextHeadline3, TextBody, SpinnerWrapper } from './style.js'

const Channel = ({
  isMobile,
  currentUserId,
  selectedChannel,
  channelsHasLoaded,
  pathnameId,
  isAdReplyView = false,
}) => {
  if (!selectedChannel && !pathnameId && channelsHasLoaded) {
    return (
      <InfoContainer data-testid="no-selected-channel">
        <IconIllustrativeMessage width={120} height={120} />
        <TextHeadline3 tagName="h2">Ingen konversation har valts</TextHeadline3>
        <TextBody>Välj ett meddelande för att svara.</TextBody>
      </InfoContainer>
    )
  }
  if (!selectedChannel) {
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    )
  }

  return (
    <LoadedChannel
      key={selectedChannel.url}
      channelsHasLoaded={channelsHasLoaded}
      currentUserId={currentUserId}
      isMobile={isMobile}
      selectedChannel={selectedChannel}
      pathnameId={pathnameId}
      isAdReplyView={isAdReplyView}
    />
  )
}

Channel.propTypes = {
  // State if current device is a mobile.
  isMobile: PropTypes.bool,
  // Current user Sendbird ID (user_id: https://docs.sendbird.com/platform/user#_4_resource_representation).
  currentUserId: PropTypes.string.isRequired,
  // Current user selected channel (https://docs.sendbird.com/platform/group_channel#_4_resource_representation).
  selectedChannel: PropTypes.object,
  // State set if channels has loaded.
  channelsHasLoaded: PropTypes.bool,
  // Selected channel id.
  pathnameId: PropTypes.string,
  // If rendered in AdReplyView.
  isAdReplyView: PropTypes.bool,
}

export default React.memo(Channel)
